import React, { useCallback } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import ControlPlayResume from '@splunk/react-icons/ControlPlayResume';
import { ActionButton, useActionButtonClick } from '../ActionButton';
import type { BaseButtonProps } from '../BaseButton';
import { getButtonTitle } from '../utils/getButtonTitle';

const playResumeIcon = <ControlPlayResume />;

export const PauseResumeButton = ({
    itemId,
    dashboardApi,
    screenReaderText,
    itemDefinition,
    ...rest
}: BaseButtonProps): JSX.Element | null => {
    const togglePause = useCallback(() => {
        if (typeof itemId !== 'string') {
            return;
        }
        // dashboardApi and itemId have to exist to execute this callback
        dashboardApi?.togglePause(itemId);
    }, [dashboardApi, itemId]);

    const handleOnClick = useActionButtonClick('togglePause', togglePause);

    const buttonTitle = getButtonTitle({
        base: _('Pause/Resume'),
        screenReaderText,
    });

    if (!itemId || !dashboardApi || !itemDefinition?.dataSources?.primary) {
        return null;
    }

    // if this button is to be used for more than just testing then it shouldn't render when the controller isn't auto-refreshing/real-time
    // can get controller with: dashboardApi.getDataSourceRegistry()?.getDataSourceController(itemDefinition.dataSources.primary)

    return (
        <ActionButton
            {...rest}
            data-test="pause-resume-button"
            onClick={handleOnClick}
            icon={playResumeIcon}
            title={buttonTitle}
        />
    );
};
